module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "tbl01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Figures")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c01_r1#FIG-1.1-section-1-6-1-1"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 1.1")])]), _vm._v(" King Abdul Aziz ibn Saud")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c01_r1#FIG-1.2-section-1-6-1-1-1"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 1.2")])]), _vm._v(" King Abdul Meets with FDR on USS Quincy")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c02_r1#FIG-2.1-section-1-6-2-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 2.1")])]), _vm._v(" Dammam Dome Area")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c02_r1#FIG-2.2-section-1-6-2-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 2.2")])]), _vm._v(" Saudi Arabia’s Eastern Province Oilfields: The World’s Most Prolific Petroleum Resource")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c03_r1#FIG-3.1-section-1-6-3-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 3.1")])]), _vm._v(" U.S. Crude Oil Production, 1945-2000")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c03_r1#FIG-3.2-section-1-6-3-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 3.2")])]), _vm._v(" Growth in Global Oil Demand from 1945-2002")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c03_r1#FIG-3.3-section-1-6-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 3.3")])]), _vm._v(" Saudi Oil Production Growth, 1950-1982")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c03_r1#FIG-3.4-section-1-6-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 3.4")])]), _vm._v(" King Faisal and Sheikh Zaki Yamani")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c03_r1#FIG-3.5-section-1-6-3-4-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 3.5")])]), _vm._v(" Middle East Light Oil Prices")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c04_r1#FIG-4.1-section-1-6-4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 4.1")])]), _vm._v(" Ahmed Zaki Yamani. Sheikh Yamani was the Saudi Arabian oil minister and public face of OPEC during the period of rising production and prices in the 1970s and 1980s.")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c04_r1#FIG-4.2-section-1-6-4-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 4.2")])]), _vm._v(" Ali Bin Ibrahim Al-Naimi, Saudi Arabian minister of petroleum and mineral resources at the beginning of the twenty-first century")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c05_r1#FIG-5.1-section-1-7-1-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 5.1")])]), _vm._v(" Basic Oil Reservoir Dynamics")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c05_r1#FIG-5.2-section-1-7-1-1-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 5.2")])]), _vm._v(" How Produced Oil Flows Through Aramco’s Oil Processing System, from Wellhead to Export")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c05_r1#FIG-5.3-section-1-7-1-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 5.3")])]), _vm._v(" Contribution of Six Royal Fields to Saudi Arabia Oil Output")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c05_r1#FIG-5.4-section-1-7-1-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 5.4")])]), _vm._v(" The core Saudi production region covers only 17,140 Square miles and fits into a corner of Utah.")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c06_r1#FIG-6.1-section-1-7-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 6.1")])]), _vm._v(" The Oilfield Development and Production Cycle")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c06_r1#FIG-6.2-section-1-7-2-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 6.2")])]), _vm._v(" Typical Changes in Produced Fluids Volumes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c06_r1#FIG-6.3-section-1-7-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 6.3")])]), _vm._v(" Producing an Oil Reservoir with an Active Water Drive")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c06_r1#FIG-6.4-section-1-7-2-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 6.4")])]), _vm._v(" How Water Alters Oil Extraction Techniques")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c07_r1#FIG-7.1-section-1-8-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 7.1")])]), _vm._v(" Ghawar Field and Its Six Operating Areas")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c07_r1#FIG-7.2-section-1-8-1-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 7.2")])]), _vm._v(" Various Zones Within Arab D Formation")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c08_r1#FIG-8.1-section-1-8-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 8.1")])]), _vm._v(" Abqaiq Oilfield")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c08_r1#FIG-8.2-section-1-8-2-1-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 8.2")])]), _vm._v(" Reviving Dead Wells with a Multiphase Pump")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c08_r1#FIG-8.3-section-1-8-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 8.3")])]), _vm._v(" The Offshore Safaniya Field")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c08_r1#FIG-8.4-section-1-8-2-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 8.4")])]), _vm._v(" Berri Field")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.1-section-1-8-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.1")])]), _vm._v(" The Offshore Zuluf and Marjan Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.2-section-1-8-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.2")])]), _vm._v(" The Remote Shaybah Oilfield")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.3-section-1-8-3-2-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.3")])]), _vm._v(" Maximum Reservoir Contact (MRC) Well Design")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.4-section-1-8-3-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.4")])]), _vm._v(" Khurais Field")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.5-section-1-8-3-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.5")])]), _vm._v(" Qatif and Abu Sa’fah Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.6-section-1-8-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.6")])]), _vm._v(" The Khursaniyah, Abu Hadriyah, and Fadhili Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.7-section-1-8-3-4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.7")])]), _vm._v(" The Hawtah Trend Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c09_r1#FIG-9.8-section-1-8-3-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 9.8")])]), _vm._v(" The Neutral Zone Fields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c10_r1#FIG-10.1-section-1-8-4-3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 10.1")])]), _vm._v(" Recent Saudi Arabian Exploration Activity")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c11_r1#FIG-11.1-section-1-8-5-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 11.1")])]), _vm._v(" Saudi Arabian Gas Production Growth")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c12_r1#FIG-12.1-section-1-9-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 12.1")])]), _vm._v(" Proven Oil Reserves Growth, 1973-2003")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_c13_r1#FIG-13.1-section-1-9-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure 13.1")])]), _vm._v(" Production Profiles for Eight Giant or Super-Giant Oilfields")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/simm_9781118040522_oeb_ap2_r1#FIG-b.1-section-1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("Figure B.1")])]), _vm._v(" The Oil Pyramid—the Importance of the Giant Oilfields")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c1dbeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simm_9781118040522_oeb_tbl01_r1.vue
// module id = 60
// module chunks = 0